import React, {useRef, useCallback} from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import {useStores} from '../../../Hooks';
import {MembersRequester} from '../../Domain/Groups/MembersRequester';
import {GroupRow, GroupLabel} from '../../Domain/Groups/helpers/GroupRow';

const GroupsSelector = ({selectedGroups, onGroupsChange}) => {
    const {modalStore, generalStore} = useStores();
    const groupsRef = useRef(null);
    const fetchedGroupsCache = useRef(new Map());

    const openGroupsModal = useCallback(() => {
        const currentGroupIds = selectedGroups.map((g) => g.GroupId);
        modalStore.modalData.genericSelectData = {
            anchorEl: groupsRef.current,
            title: 'Select Groups',
            searchPlaceHolder: 'Search groups...',
            isMultipleChoices: true,
            showActionBar: false,
            showSelectedCount: true,
            fetchData: async (skip, limit, searchStr) => {
                const result = await MembersRequester.getGroupsForSelect(
                    generalStore.workspace, skip, limit, searchStr,
                );
                if (result?.data) {
                    result.data.forEach((g) => fetchedGroupsCache.current.set(g.GroupId, g));
                }
                return {...result, initialSelected: currentGroupIds};
            },
            renderItem: (item, isChecked, onToggle) => (
                <GroupRow key={item.GroupId} group={item} checked={isChecked} onToggle={onToggle} />
            ),
            handleSelect: (selectedGroupIds) => {
                const populated = selectedGroupIds.map((id) =>
                    fetchedGroupsCache.current.get(id) || {GroupId: id, GroupName: id},
                );
                onGroupsChange(populated);
            },
        };
        modalStore.isGenericSelectSearchModalOpen = true;
    }, [selectedGroups, generalStore.workspace, modalStore, onGroupsChange]);

    return (
        <div className="flex flex-col gap-1.5">
            <label className="text-sm text-main-normal">
                <span className="font-medium">Groups</span>
                <span className="text-main-disabled">  (optional)</span>
            </label>
            <div
                ref={groupsRef}
                className="flex flex-wrap items-center gap-1 p-2 rounded-menu border border-panels-normal bg-windowsandmenus-normal cursor-pointer hover:bg-panels-normal hover:border-classic-button-normal"
                style={{minHeight: 40}}
                onClick={openGroupsModal}
            >
                {selectedGroups.length === 0 ? (
                    <span className="text-sm text-main-disabled">Select groups</span>
                ) : (
                    selectedGroups.map((group) => (
                        <GroupLabel key={group.GroupId} group={group} />
                    ))
                )}
                <KeyboardArrowDownIcon style={{fontSize: 20}} className="text-main-light flex-shrink-0 ml-auto" />
            </div>
        </div>
    );
};

export default GroupsSelector;
